var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 266,
    viewBox: "0 0 276 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.701 259.402C205.049 259.402 256.402 208.049 256.402 144.701C256.402 81.3534 205.049 30 141.701 30C78.3534 30 27 81.3534 27 144.701C27 208.049 78.3534 259.402 141.701 259.402Z",
    fill: "url(#paint0_linear_255_2665)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.422 199.606C139.422 194.868 143.263 191.027 148.001 191.027H197.776C204.577 191.027 211.078 193.04 216.083 196.719C221.087 200.397 225.058 206.181 225.058 213.359C225.058 220.537 221.088 226.321 216.086 230.001C211.081 233.684 204.579 235.7 197.776 235.7H79.506C74.7681 235.7 70.9272 231.859 70.9272 227.121C70.9272 222.383 74.7681 218.542 79.506 218.542H197.776C201.304 218.542 204.154 217.479 205.918 216.181C207.685 214.881 207.901 213.785 207.901 213.359C207.901 212.935 207.687 211.842 205.921 210.544C204.158 209.248 201.307 208.185 197.776 208.185L147.5 206.5C142.762 206.5 139.422 204.344 139.422 199.606Z",
    fill: "url(#paint1_linear_255_2665)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.5 97.154C218.629 92.9346 222.452 90 226.82 90H265.841C271.169 90 275.488 94.3193 275.488 99.6474C275.488 104.976 271.169 109.295 265.841 109.295H234.226L222.969 151.367C221.592 156.514 216.303 159.57 211.156 158.193C206.009 156.816 202.953 151.527 204.33 146.38L217.5 97.154Z",
    fill: "url(#paint2_linear_255_2665)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.164 61.0498H92.1188L82.8853 81.2317H199.922L209.164 61.0498Z",
    fill: "url(#paint3_linear_255_2665)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.198 58H73.6431L82.885 81.2316H159.431L150.198 58Z",
    fill: "url(#paint4_linear_255_2665)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.727 58H168.673L159.431 81.2316H201.485L210.727 58Z",
    fill: "url(#paint5_linear_255_2665)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.493 81.2314H124.938V157.786H201.493V81.2314Z",
    fill: "url(#paint6_linear_255_2665)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M159.44 81.2314H82.8853V157.786H159.44V81.2314Z",
    fill: "url(#paint7_linear_255_2665)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.077 265.364C119.619 265.364 128.977 256.007 128.977 244.464C128.977 232.922 119.619 223.564 108.077 223.564C96.534 223.564 87.1768 232.922 87.1768 244.464C87.1768 256.007 96.534 265.364 108.077 265.364Z",
    fill: "#6FCFE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M211.799 115.871H67.772C56.9756 115.871 49.0008 125.029 51.4423 134.608L63.1763 190.956C64.9419 197.874 71.7087 202.783 79.506 202.783L206.5 211L228.163 134.634C233.5 119 222.621 115.871 211.799 115.871Z",
    fill: "url(#paint8_linear_255_2665)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 255C113.299 255 118 250.299 118 244.5C118 238.701 113.299 234 107.5 234C101.701 234 97 238.701 97 244.5C97 250.299 101.701 255 107.5 255Z",
    fill: "url(#paint9_linear_255_2665)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_2665",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 115,
    width: 178,
    height: 96
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M211.799 115.871H67.772C56.9756 115.871 49.0008 125.029 51.4423 134.608L63.1763 190.956C64.9419 197.874 71.7087 202.783 79.506 202.783L206.5 211L228.163 134.634C230.604 125.029 222.621 115.871 211.799 115.871Z",
    fill: "url(#paint10_linear_255_2665)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_2665)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9998,
    height: 55.7063,
    rx: 5.9999,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 150.876 159.145)",
    fill: "url(#paint11_linear_255_2665)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9998,
    height: 211.29,
    rx: 5,
    transform: "matrix(0.00661527 0.999978 -0.999997 0.00256955 255.3 119.225)",
    fill: "#61C2D8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9998,
    height: 55.7063,
    rx: 5.9999,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 184.79 159.289)",
    fill: "url(#paint12_linear_255_2665)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9998,
    height: 55.7063,
    rx: 5.9999,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 116.962 159)",
    fill: "url(#paint13_linear_255_2665)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.9998,
    height: 55.7063,
    rx: 5.9999,
    transform: "matrix(0.999966 0.00825468 -0.0123002 0.999924 82.6851 159)",
    fill: "url(#paint14_linear_255_2665)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.354 3.08425C181.893 0.523029 179.181 -0.681773 177.297 0.393243C175.412 1.46826 175.069 4.41601 176.53 6.97723C176.572 7.04969 176.614 7.12107 176.657 7.19133C175.699 7.38789 174.799 8.3245 174.446 9.61476C173.992 11.2754 174.616 12.893 175.84 13.2278C177.064 13.5626 178.425 12.4878 178.879 10.8272C179.003 10.3722 179.047 9.92057 179.019 9.4976C180.226 10.158 181.536 10.2684 182.588 9.66825C183.514 9.13992 184.068 8.15926 184.218 6.99445C184.47 7.12554 184.746 7.23408 185.039 7.31433C186.7 7.76852 188.317 7.14439 188.652 5.9203C188.987 4.69621 187.912 3.3357 186.251 2.88151C185.182 2.58911 184.131 2.74362 183.429 3.2174C183.404 3.17291 183.38 3.12852 183.354 3.08425Z",
    fill: "url(#paint15_linear_255_2665)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8734 13.1176C96.0161 13.9914 94.9366 14.4493 93.8467 14.2805C92.5842 14.085 91.5893 13.092 91.0768 11.7136C90.8446 12.0275 90.5518 12.3213 90.2046 12.5753C88.8153 13.592 87.0815 13.586 86.332 12.5619C85.5826 11.5378 86.1013 9.88337 87.4907 8.86667C88.5937 8.05952 89.9138 7.89695 90.7861 8.37665C91.246 5.47653 93.3436 3.39718 95.4811 3.72823C97.5889 4.05469 98.9507 6.60364 98.5671 9.45853C99.3938 9.5468 100.282 10.0757 100.92 10.9472C101.937 12.3366 101.931 14.0704 100.907 14.8198C99.8826 15.5693 98.2282 15.0505 97.2115 13.6612C97.0823 13.4846 96.9696 13.3025 96.8734 13.1176Z",
    fill: "url(#paint16_linear_255_2665)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.968 126.461C19.4856 124.317 22.5352 124.317 23.0528 126.461L24.7947 133.677C24.9796 134.443 25.5778 135.041 26.344 135.226L33.56 136.968C35.7041 137.486 35.7041 140.535 33.56 141.053L26.344 142.795C25.5778 142.98 24.9796 143.578 24.7947 144.344L23.0528 151.56C22.5352 153.704 19.4856 153.704 18.968 151.56L17.2261 144.344C17.0411 143.578 16.4429 142.98 15.6767 142.795L8.46073 141.053C6.31671 140.535 6.3167 137.486 8.46073 136.968L15.6767 135.226C16.4429 135.041 17.0411 134.443 17.2261 133.677L18.968 126.461Z",
    fill: "url(#paint17_linear_255_2665)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M240.968 198.461C241.486 196.317 244.535 196.317 245.053 198.461L246.795 205.677C246.98 206.443 247.578 207.041 248.344 207.226L255.56 208.968C257.704 209.486 257.704 212.535 255.56 213.053L248.344 214.795C247.578 214.98 246.98 215.578 246.795 216.344L245.053 223.56C244.535 225.704 241.486 225.704 240.968 223.56L239.226 216.344C239.041 215.578 238.443 214.98 237.677 214.795L230.461 213.053C228.317 212.535 228.317 209.486 230.461 208.968L237.677 207.226C238.443 207.041 239.041 206.443 239.226 205.677L240.968 198.461Z",
    fill: "url(#paint18_linear_255_2665)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.628 74.9869C52.0354 74.9869 53.9869 73.0354 53.9869 70.628C53.9869 68.2207 52.0354 66.2692 49.628 66.2692C47.2207 66.2692 45.2692 68.2207 45.2692 70.628C45.2692 73.0354 47.2207 74.9869 49.628 74.9869ZM49.628 78.2561C53.8409 78.2561 57.2561 74.8409 57.2561 70.628C57.2561 66.4152 53.8409 63 49.628 63C45.4152 63 42 66.4152 42 70.628C42 74.8409 45.4152 78.2561 49.628 78.2561Z",
    fill: "url(#paint19_linear_255_2665)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0142 187.053C31.6812 185.746 32.8869 184.57 34.1845 184.934L42.943 187.396C44.2406 187.76 44.6568 189.393 43.6922 190.334L37.1815 196.689C36.2169 197.63 34.595 197.174 34.262 195.868L32.0142 187.053Z",
    fill: "url(#paint20_linear_255_2665)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M258.713 157.018C260.019 156.687 261.194 157.894 260.828 159.191L258.356 167.947C257.989 169.244 256.356 169.658 255.416 168.692L249.07 162.173C248.13 161.207 248.588 159.586 249.894 159.255L258.713 157.018Z",
    fill: "url(#paint21_linear_255_2665)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.128 65.6298C232.062 65.6298 233.63 64.062 233.63 62.128C233.63 60.1941 232.062 58.6263 230.128 58.6263C228.194 58.6263 226.626 60.1941 226.626 62.128C226.626 64.062 228.194 65.6298 230.128 65.6298ZM230.128 68.2561C233.512 68.2561 236.256 65.5124 236.256 62.128C236.256 58.7436 233.512 56 230.128 56C226.744 56 224 58.7436 224 62.128C224 65.5124 226.744 68.2561 230.128 68.2561Z",
    fill: "url(#paint22_linear_255_2665)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 114,
    width: 189,
    height: 13,
    rx: 6.5,
    fill: "url(#paint23_linear_255_2665)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1205 16.1055C91.3993 22.9907 96.9748 37.4579 105.581 38.6055C121.506 40.7288 118.581 22.1055 109.081 25.6055C97.775 29.7709 109.089 47.5891 124.581 51.6055",
    stroke: "#5EC0D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.635 14.367C193.099 32.7874 168.024 52.4534 161.082 56.0969",
    stroke: "#5EC0D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.57 265.364C186.113 265.364 195.47 256.007 195.47 244.464C195.47 232.922 186.113 223.564 174.57 223.564C163.027 223.564 153.67 232.922 153.67 244.464C153.67 256.007 163.027 265.364 174.57 265.364Z",
    fill: "#6FCFE4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 255C180.299 255 185 250.299 185 244.5C185 238.701 180.299 234 174.5 234C168.701 234 164 238.701 164 244.5C164 250.299 168.701 255 174.5 255Z",
    fill: "url(#paint24_linear_255_2665)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_2665",
    x1: 140.817,
    y1: -7.34947,
    x2: 143.167,
    y2: 395.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_2665",
    x1: 71,
    y1: 152.5,
    x2: 117.645,
    y2: 198.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_2665",
    x1: 311.08,
    y1: 95.559,
    x2: 206.579,
    y2: 97.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_2665",
    x1: 82.7422,
    y1: 65.7075,
    x2: 209.646,
    y2: 70.8629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41ACC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_255_2665",
    x1: 116.537,
    y1: 58,
    x2: 116.537,
    y2: 81.2316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9ECF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_255_2665",
    x1: 185.079,
    y1: 58,
    x2: 185.079,
    y2: 81.2316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92DDEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6CCFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_255_2665",
    x1: 122.64,
    y1: 138.638,
    x2: 233.242,
    y2: 140.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.392237,
    stopColor: "#77D3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_255_2665",
    x1: 104,
    y1: 123.5,
    x2: 145.545,
    y2: 134.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_255_2665",
    x1: 50.7989,
    y1: 138.138,
    x2: 229.552,
    y2: 140.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_255_2665",
    x1: 96.3695,
    y1: 249.747,
    x2: 126.709,
    y2: 250.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_255_2665",
    x1: 50.7989,
    y1: 138.138,
    x2: 229.552,
    y2: 140.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_255_2665",
    x1: -0.360303,
    y1: 41.7729,
    x2: 16.9806,
    y2: 41.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_255_2665",
    x1: -0.360303,
    y1: 41.7729,
    x2: 16.9806,
    y2: 41.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_255_2665",
    x1: -0.360303,
    y1: 41.7729,
    x2: 16.9806,
    y2: 41.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_255_2665",
    x1: -0.360303,
    y1: 41.7729,
    x2: 16.9806,
    y2: 41.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62C9E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62C9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_255_2665",
    x1: 174.282,
    y1: 3.06689,
    x2: 188.791,
    y2: 3.16908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_255_2665",
    x1: 92.4807,
    y1: 4.10423,
    x2: 101.781,
    y2: 14.1164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_255_2665",
    x1: -0.0475913,
    y1: 127.698,
    x2: 42.2492,
    y2: 127.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_255_2665",
    x1: 221.952,
    y1: 199.698,
    x2: 264.249,
    y2: 199.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_255_2665",
    x1: 41.9827,
    y1: 66.5209,
    x2: 57.339,
    y2: 66.6206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_255_2665",
    x1: 27.8081,
    y1: 193.134,
    x2: 40.5004,
    y2: 180.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_255_2665",
    x1: 252.637,
    y1: 152.804,
    x2: 264.848,
    y2: 165.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_255_2665",
    x1: 223.986,
    y1: 58.8285,
    x2: 236.323,
    y2: 58.9086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_255_2665",
    x1: 242.5,
    y1: 121,
    x2: 41.9664,
    y2: 85.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63C8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52D2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_255_2665",
    x1: 163.369,
    y1: 249.747,
    x2: 193.709,
    y2: 250.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.d7e9737595d5a68b8ca9090f07008b87.svg";
export { ForwardRef as ReactComponent };